// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2m8PJ","footer":"ModalFilter_footer__2EnId"};